const styles = `:host([appearance=navrailitem]) {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  outline: none;
}
:host([appearance=navrailitem]) .control {
  border-width: 1px;
  border-style: solid;
  width: 72px;
  min-height: 72px;
  border-color: transparent;
  display: flex;
  outline: 0;
  cursor: pointer;
  box-sizing: border-box;
  flex-direction: column;
  color: var(--goto-text-02);
  font: var(--goto-caption-small-strong);
  gap: 4px;
  align-items: center;
  justify-content: center;
  --goto-icon-size: 24px;
  --goto-icon-color: var(--goto-text-02);
  padding: 14px 2px;
  position: relative;
  text-decoration: none;
  outline: 0;
}
:host([appearance=navrailitem]) .control .end {
  position: absolute;
  right: var(--goto-spacing-02);
  top: var(--goto-spacing-03);
}
:host([appearance=navrailitem]) .control .content {
  display: inline-flex;
  hyphens: auto;
  text-align: center;
  word-break: break-word;
}
:host([appearance=navrailitem]) ::slotted(chameleon-badge-counter.dot) {
  margin-right: 8px;
}
:host([appearance=navrailitem]) ::slotted(chameleon-badge-counter) {
  box-shadow: 0 0 1px 2px var(--goto-nav-rail-badge-border, var(--goto-ui-base-01));
}

:host .start {
  height: var(--goto-spacing-06);
}

:host([appearance=navrailitem][size=small]) .control {
  width: 56px;
  height: 56px;
  min-height: unset;
  gap: 0;
}
:host([appearance=navrailitem][size=small]) .control .content {
  display: none;
}
:host([appearance=navrailitem][size=small]) ::slotted(chameleon-badge-counter.dot) {
  margin-right: 0;
}

:host([appearance=navrailitem][size=large]) .control {
  width: 164px;
  min-height: 56px;
  gap: 0;
  display: grid;
  grid-template-columns: 42px 1fr;
  padding-left: 16px;
  border-left-width: 0;
}
:host([appearance=navrailitem][size=large]) .start {
  justify-self: left;
}
:host([appearance=navrailitem][size=large]) span[part=end] {
  display: none;
}
:host([appearance=navrailitem][size=large]) span[part=end].end {
  display: unset;
  right: unset;
  left: 35px;
}
:host([appearance=navrailitem][size=large]) ::slotted(chameleon-badge-counter.dot) {
  margin-right: 0;
}

:host([appearance=menuitem][size=small]) .start {
  height: 14px;
}

:host([appearance=navrailitem]:focus-visible) .control {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
  --goto-nav-rail-badge-border: var(--goto-hover-tertiary);
}

:host([appearance=navrailitem]:hover) .control {
  background-color: var(--goto-hover-tertiary);
  --goto-nav-rail-badge-border: var(--goto-pressed-tertiary);
}

:host([appearance=navrailitem]:active) .control {
  background-color: var(--goto-pressed-tertiary);
}

:host([appearance=navrailitem][selected]) .control {
  color: var(--goto-icon-01);
  --goto-icon-color: var(--goto-icon-01);
}

:host([appearance=menuitem]) {
  --goto-icon-color: var(--goto-text-02);
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  border-width: 1px;
  border-style: solid;
  display: flex;
  align-items: center;
  border-color: var(--goto-interactive-02);
  cursor: pointer;
  font: var(--goto-body-small);
  height: 36px;
  width: 100%;
  transition: unset;
  borderRadius: 0;
  padding: 0 4px;
  position: relative;
  color: var(--goto-text-01);
  outline: 0;
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  gap: 12px;
  list-style: none;
  outline: 0;
  position: relative;
  width: 100%;
}
:host([appearance=menuitem]) .start,
:host([appearance=menuitem]) .end {
  --goto-icon-size: 20px;
  display: initial;
  line-height: 1;
}
:host([appearance=menuitem]) .start {
  margin-left: 12px;
}
:host([appearance=menuitem]) .end {
  margin-right: 12px;
}
:host([appearance=menuitem]) ::slotted(a) {
  color: inherit;
  text-decoration: none;
}
:host([appearance=menuitem]) ::slotted(svg) {
  color: var(--goto-text-02);
  height: 20px;
  width: 20px;
}
:host([appearance=menuitem]) .control {
  color: var(--goto-text-01);
  display: inline-flex;
  gap: 12px;
  text-decoration: none;
  width: 100%;
}
:host([appearance=menuitem]) .content {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host([appearance=menuitem]) .expand-collapse-glyph-container {
  display: none;
}

:host([appearance=menuitem][toggleable]) {
  --goto-icon-color: var(--goto-interactive-01);
  padding: 0 16px;
}
:host([appearance=menuitem][toggleable]) .start,
:host([appearance=menuitem][toggleable]) .end {
  margin: 0;
}
:host([appearance=menuitem][toggleable]) [part=start] {
  display: flex;
  width: 20px;
}
:host([appearance=menuitem][toggleable]) ::slotted(svg) {
  color: var(--goto-interactive-01);
}

:host([appearance=menuitem][variant=danger]) {
  color: var(--goto-danger-01);
  --goto-icon-color: var(--goto-danger-01);
}
:host([appearance=menuitem][variant=danger]) ::slotted(svg) {
  color: var(--goto-danger-01);
}

:host([appearance=menuitem][variant=secondary]) {
  --goto-icon-color: var(--goto-interactive-01);
}
:host([appearance=menuitem][variant=secondary]) ::slotted(svg) {
  color: var(--goto-interactive-01);
}

:host([appearance=menuitem]:not([disabled]):focus-visible) {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
  color: var(--goto-text-01);
  --goto-icon-color: var(--goto-text-01);
  color: var(--goto-text-01);
}
:host([appearance=menuitem]:not([disabled]):focus-visible) .content::slotted(*) {
  color: var(--goto-text-01);
}
:host([appearance=menuitem]:not([disabled]):focus-visible) ::slotted(svg) {
  color: var(--goto-text-01);
}

:host([appearance=menuitem]:not([disabled]):hover) {
  background-color: var(--goto-interactive-01);
  border-color: var(--goto-interactive-01);
  color: var(--goto-text-04);
  --goto-icon-color: var(--goto-text-04);
  --goto-presence-available: var(--goto-text-04);
  --goto-presence-busy: var(--goto-text-04);
  --goto-presence-away: var(--goto-text-04);
  --goto-presence-dnd: var(--goto-text-04);
  --goto-presence-offline: var(--goto-text-04);
  --goto-badge-color: var(--goto-icon-01);
  --goto-badge-background-color: var(--goto-ui-01);
}
:host([appearance=menuitem]:not([disabled]):hover) .content::slotted(*),
:host([appearance=menuitem]:not([disabled]):hover) .control {
  color: var(--goto-text-04);
}
:host([appearance=menuitem]:not([disabled]):hover) ::slotted(svg) {
  color: var(--goto-text-04);
}

:host([appearance=menuitem][disabled]),
:host([appearance=menuitem][disabled]:hover) {
  color: var(--goto-text-03);
  background: none;
  border-color: transparent;
}

:host([appearance=menuitem][disabled]:focus-visible) {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}

:host([appearance=menuitem][size=small]) {
  --goto-icon-size: 14px;
  font: var(--goto-caption-default-01);
  height: 24px;
  padding: 4px;
}
:host([appearance=menuitem][size=small]) .start,
:host([appearance=menuitem][size=small]) .end {
  --goto-icon-size: 14px;
}
:host([appearance=menuitem][size=small]) ::slotted(svg) {
  height: 14px;
  width: 14px;
}`; export default styles;